import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { RavalButton, AudioButton, GeneralUtils } from "../../utils/Utils";
import { GameManager } from "../../GameManager";
import { AudioManager } from "../../AudioManager";

export class HomeScene extends Phaser.Scene {

    public static currentInstance: HomeScene;

    private titleImageTop: Phaser.GameObjects.Image;
    private titleImageDown: Phaser.GameObjects.Image;
    private backgroundImage: Phaser.GameObjects.Image;
    private homeContainer: Phaser.GameObjects.Container;
    private muteButton: AudioButton;
    private spawnCounter: number;
    private alternator: boolean;

    constructor() {

        super({ key: "HomeScene" });
    }

    public create(): void {

        HomeScene.currentInstance = this;

        this.homeContainer = new Phaser.GameObjects.Container(this, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2);
        this.homeContainer.scaleX = GameVars.scaleXMult;
        this.homeContainer.scaleY = GameVars.scaleYMult;
        this.add.existing(this.homeContainer);

        // Create Background Images
        this.backgroundImage = new Phaser.GameObjects.Image(this, -GameConstants.GAME_WIDTH * GameVars.scaleXMultInverse / 2, -GameConstants.GAME_HEIGHT * GameVars.scaleYMultInverse / 2, "texture_atlas_1", "background.png");
        this.backgroundImage.setDisplaySize(GameConstants.GAME_WIDTH * GameVars.scaleXMultInverse, GameConstants.GAME_HEIGHT * GameVars.scaleYMultInverse);
        this.backgroundImage.setOrigin(0);
        this.homeContainer.add(this.backgroundImage);

        // Create title
        this.titleImageTop = new Phaser.GameObjects.Image(this, 0, 0, "texture_atlas_1", "pixel_title.png");
        this.titleImageTop.setPosition(0, -((GameConstants.GAME_HEIGHT) / 2) + this.titleImageTop.height / 2 + (GameConstants.GAME_HEIGHT / 10));
        this.titleImageTop.x -= 500;
        this.titleImageTop.y += 150;
        this.titleImageTop.setOrigin(.5);
        this.homeContainer.add(this.titleImageTop);

        let topTween = this.tweens.add({
            targets: this.titleImageTop,
            props: {
                x: 0,
                y: -((GameConstants.GAME_HEIGHT) / 2) + this.titleImageTop.height / 2 + GameConstants.GAME_HEIGHT / 10,
            },
            ease: "Elastic",
            easeParams: [0, .5],
            duration: 1000
        });

        this.titleImageDown = new Phaser.GameObjects.Image(this, 0, this.titleImageTop.y + this.titleImageTop.height / 2, "texture_atlas_1", "artist.png");
        this.titleImageDown.setPosition(0, -((GameConstants.GAME_HEIGHT) / 2) + this.titleImageDown.height / 2 + ((GameConstants.GAME_HEIGHT * GameVars.scaleYMultInverse) / 15));
        this.titleImageDown.x += 500;
        this.titleImageDown.y -= 50;
        this.titleImageDown.setOrigin(.5);
        this.homeContainer.add(this.titleImageDown);

        let downTween = this.tweens.add({
            targets: this.titleImageDown,
            props: {
                x: 0,
                y: -((GameConstants.GAME_HEIGHT) / 2) + this.titleImageDown.height + (170),
            },
            ease: "Elastic",
            easeParams: [0, .5],
            duration: 1000
        });

        // Create Buttons ---------
        const playButton = new RavalButton(this, 0, ((GameConstants.GAME_HEIGHT) / 5), "texture_atlas_1", "btn_play.png", "btn_play_over.png");
        playButton.setScale(0);
        playButton.setOrigin(.5);
        this.homeContainer.add(playButton);

        playButton.onUp(function (): void {

            if (GameConstants.SPONSOR === GameConstants.SPONSOR_FUNO) {
                AudioManager.playSound("music_loop", true);
            }

            if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {
                LaggedAPI.init("pixel_artistt_inints", "lagdevaF3001");
            }

            this.scene.start("LevelSelectionScene");

        }, this);

        const muteButton = new AudioButton(this);
        muteButton.setPosition(GameConstants.GAME_WIDTH - 10, 10);
        muteButton.setScale(GameVars.scaleXMult, GameVars.scaleYMult);
        muteButton.alpha = 0;
        this.add.existing(muteButton);

        // Sponsor text 
        const copyrightLabel = this.add.text(
            GameConstants.GAME_WIDTH - 10,
            GameConstants.GAME_HEIGHT - 10 * GameVars.scaleYMult, "made by ravalmatic, licensed to " + GameConstants.SPONSOR, { font: "23px Arial", fill: "#FFFFFF" });
        copyrightLabel.scaleY = GameVars.scaleYMult;
        copyrightLabel.setOrigin(1);
        copyrightLabel.alpha = .5;

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_FUNO) {
            copyrightLabel.visible = false;
        } else {
            AudioManager.playSound("music_loop", true);
        }

        const tween = this.tweens.create({
            targets: [playButton],
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            delay: 800,
            duration: 250
        });
        tween.play(true);

        const tween2 = this.tweens.create({
            targets: [copyrightLabel, muteButton],
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 1800
        });
        tween2.play(true);
    }

    public update(time: number, delta: number): void {

        super.update(time, delta);

        if (this.spawnCounter > 0) {

            this.spawnCounter--;

        } else {

            let drawFileName = GameManager.getFileFormatCategory(GameManager.getCategoryFromID(Phaser.Math.RND.pick([0, 1, 2, 3, 4, 5]))) + "_draw_" + GeneralUtils.getAsPaddedNumber(Phaser.Math.RND.pick([1, 2, 3, 4, 5, 6]), 2) + ".png";

            const image = new Phaser.GameObjects.Image(this, GameConstants.GAME_WIDTH * .5 + 250, 0 + (Phaser.Math.RND.frac() * 350), "texture_atlas_0", drawFileName);

            this.alternator = !this.alternator;

            image.setOrigin(0.5);
            image.angle = this.alternator ? 20 + Phaser.Math.RND.frac() * 25 : -20 + Phaser.Math.RND.frac() * -25,
                image.setScale(2 + Phaser.Math.RND.frac());
            this.homeContainer.add(image);
            this.homeContainer.sendToBack(image);
            this.homeContainer.sendToBack(this.backgroundImage);

            const tween = this.tweens.create({
                targets: [image],
                x: -GameConstants.GAME_WIDTH * .5 - 250,
                angle: this.alternator ? -20 + Phaser.Math.RND.frac() * -25 : 20 + Phaser.Math.RND.frac() * 25,
                ease: Phaser.Math.Easing.Linear.Linear,
                duration: 10000 + Phaser.Math.RND.frac() * 2000,

            });
            tween.setCallback("onComplete", function (): void {
                image.destroy();
            }, [null], this);
            tween.play(true);

            this.spawnCounter = 80;
        }
    }
}
